__turbopack_context__.v({
  "attendeeList": "_9fGGkq_attendeeList",
  "container": "_9fGGkq_container",
  "emptyAttendees": "_9fGGkq_emptyAttendees",
  "header": "_9fGGkq_header",
  "midDot": "_9fGGkq_midDot",
  "searchInput": "_9fGGkq_searchInput",
});
